import React from 'react';

const BellOffIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
         strokeLinecap="round" strokeLinejoin="round"
    >
        <path d="M10.268 21a2 2 0 0 0 3.464 0"/>
        <path d="M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742"/>
        <path d="m2 2 20 20"/>
        <path d="M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05"/>
    </svg>
);

export default BellOffIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/BellOffIcon.jsx